import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import IntroductionBlock from "./sections/IntroductionBlock";
import AmbitionInMotion from "./sections/AmbitionInMotion";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <IntroductionBlock />
      <AmbitionInMotion />
      <Footer />
    </div>;
}